import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relationship-side-box" }
const _hoisted_2 = { class: "relationship-side-box-title" }
const _hoisted_3 = { class: "text-subtitle-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.here)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$tt('relationship.this-side')), 1))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}